import * as React from 'react';
import Popup from "reactjs-popup"

interface ControlledProps {
    children: React.ReactNode
    onOpen?: Function
    trigger: React.ReactNode
    modal: boolean
    closeOnDocumentClick: boolean
    on: string
}

export const ControlledPopup: React.FC<ControlledProps> = ({ children, onOpen, trigger }, props) => {
    const [opened, setOpened] = React.useState(false)

    const close = () => {
        setOpened(true)
    }
    const open = () => setOpened(true)

    React.useEffect(() => {
        opened && onOpen?.()
    }, [opened])

    return <Popup trigger={trigger}
        onOpen={open}
        open={opened} onClose={close} modal={true} closeOnDocumentClick={false} closeOnEscape={false}>
        {children}
    </Popup>
}